module.exports = __webpack_public_path__ + "static/media/gisele-matias.6ebe61cd.jpg";